module.exports = __webpack_public_path__ + "img/m-banner-fmugwkfb-de-DE.d7f30524.png";